// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__Dx4Z_"};